import { useQuery } from "@apollo/client";
import type {
  ProductQuery,
  ProductQueryVariables,
} from "../../../__generated__/graphql";
import { GET_PRODUCT } from "../api/product-queries";

export function useProductQuery(productId: number) {
  const { data, loading, refetch } = useQuery<
    ProductQuery,
    ProductQueryVariables
  >(GET_PRODUCT, {
    variables: { productId },
    fetchPolicy: "network-only",
  });
  const product = data?.product;
  return { product, loading, refetch };
}
